var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMasterAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "464pt",
    viewBox: "-48 0 464 464",
    width: "464pt",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0h272c26.508 0 48 21.492 48 48v384c0 17.672-14.328 32-32 32H64c-35.348 0-64-28.652-64-64V48C0 21.492 21.492 0 48 0zm0 0",
    fill: "#834b10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M336 432H64c-17.672 0-32-14.328-32-32v-16c0-17.672 14.328-32 32-32l264-40h40v88c0 17.672-14.328 32-32 32zm0 0",
    fill: "#ebebeb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M320 304h48v48h-48zm0 0",
    fill: "#cbcbcb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M320 352H64V0h256c26.508 0 48 21.492 48 48v256c0 26.508-21.492 48-48 48zm0 0",
    fill: "#a45e14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 168v-8c0-26.508 21.492-48 48-48h16V64H48C21.492 64 0 85.492 0 112zm0 0M0 344v-8c0-26.508 21.492-48 48-48h16v-48H48c-26.508 0-48 21.492-48 48zm0 0",
    fill: "#ea9d2d"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M136 80h160v160H136zm0 0",
    fill: "#fbcd87"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M272 216H168a8 8 0 01-8-8V104h16v96h96zm0 0",
    fill: "#fbb540"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M264 184c-39.746-.047-71.953-32.254-72-72v-8h16v8c.035 30.914 25.086 55.965 56 56zm0 0M144 440l-24-24-24 24v-56h48zm0 0",
    fill: "#f55648"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M336 392H64a8 8 0 010-16h272a8 8 0 010 16zm0 0",
    fill: "#cbcbcb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#834b10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104 264h72v16h-72zm0 0M104 296h56v16h-56zm0 0M192 40h56v16h-56zm0 0M280 264h56v16h-56zm0 0"
  }))));
}

export default __webpack_public_path__ + "7938a760ceaddf564d332ea7c9659291.svg";
export { SvgMasterAccount as ReactComponent };